// JOBE-0192: derive today's date string from the user's clock at render
// time instead of using a hard-coded literal. Two shapes are provided so
// the TopBar (short) and the Overview placemat (long, with time-of-day)
// can share a single source of truth.
//
// Output samples (en-US default):
//   formatTodayShort(new Date('2026-04-17T09:14:00')) → "Fri · Apr 17"
//   formatTodayLong (new Date('2026-04-17T09:14:00')) → "Fri · Apr 17 · 09:14"
//
// The browser's default locale is used (no explicit locale arg). The
// `·`-joined shape is produced by composing `Intl.DateTimeFormat`
// `formatToParts` output so the separator stays consistent across
// locales that would otherwise inject commas.

function partsByType(parts) {
  const out = {};
  for (const p of parts) out[p.type] = p.value;
  return out;
}

export function formatTodayShort(d = new Date()) {
  const fmt = new Intl.DateTimeFormat(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
  const p = partsByType(fmt.formatToParts(d));
  // e.g. "Fri · Apr 17"
  return `${p.weekday} · ${p.month} ${p.day}`;
}

export function formatTodayLong(d = new Date()) {
  const tfmt = new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const t = partsByType(tfmt.formatToParts(d));
  // e.g. "Fri · Apr 17 · 09:14"
  return `${formatTodayShort(d)} · ${t.hour}:${t.minute}`;
}
